import { makeStyles } from "@material-ui/core/styles";
import CheckinBgImg from "Assets/images/checkin-bg.svg";

export const useStyles = makeStyles((theme) => {
  return {
    toggleBtnLabel: {
      "@media(max-width:1280px)": {
        width: "80%",
        display: "block",
        textAlign: "center !important",
        margin: "0 auto",
      },
    },
    toggleBtnGroup: {
      width: "100%",
      justifyContent: "center",
      marginTop: 12,
      "& .MuiToggleButton-root": {
        borderRadius: "4px !important",
        display: "flex",
        alignItems: "center",
        padding: "8px 25px",
        background: "#FFFFFF",
        boxShadow: "0 1px 3px #00000029",
        color: "#2E2E2E",
        justifyContent: "start",
        marginRight: 12,
        border: "none !important",
        border: "solid 1px transparent",
        "&:hover": {
          background: "#FFF5ED",
          border: "solid 1px #ED7014 !important",
        },
        "& .option-count": {
          width: 18,
          height: 18,
          borderRadius: 4,
          display: "block",
          fontWeight: 500,
          marginRight: 10,
          textAlign: "center",
          lineHeight: "16px",
          border: "solid 1px #B4B4B4",
        },
        "&.Mui-selected": {
          background: "#FFF5ED",
          border: "solid 1px #ED7014 !important",
          boxShadow: "0 1px 6px #00000029",
          color: "#2E2E2E",
          "&:hover": {
            background: "#FFF5ED",
            border: "solid 1px #ED7014 !important",
          },
          "& .option-count": {
            border: "solid 1px #ED7014",
          },
        },
        "&.Mui-disabled": {
          opacity: 1,
          color: "#BEBEBE",
        },
      },
    },
    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: "rotate(180deg)",
    },
    expandContent: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center",
      "&:hover": {
        background: "none",
      },
      "&:focus": {
        background: "none",
      },
    },

    checkinModal: {
      "&.MuiDialog-root": {
        zIndex: "1300 !important",
      },
      "& .MuiDialog-paper": {
        width: 1000,
        maxWidth: "none",
        overflow: "unset",
        height: 700,
        "@media(max-width: 1280px)": {
          width: 920,
        },
        "@media(max-width: 1180px)": {
          width: 820,
        },
        "@media(max-width: 768px)": {
          width: "82%",
        },
        [theme.breakpoints.down("xs")]: {
          width: "100%",
          height: "100%",
          margin: 0,
          maxHeight: "100%",
        },
      },
      "& .MuiDialogTitle-root": {
        boxShadow: "0px 1px 3px #00000029",
        "& h2": {
          fontSize: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        },
      },
      "& .upload-card, .MuiDropzoneArea-root, .MuiInputBase-input, .dropzone-loader":
        {
          background: "#fff !important",
        },
    },
    dialogContent: {
      padding: 0,
      "& .added-attachment": {
        maxWidth: 228,
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
      },
    },
    // checkinForm
    checkinForm: {
      width: "calc(100% - 400px)",
      display: "flex",
      "@media(max-width: 1180px)": {
        width: "calc(100% - 350px)",
      },
      "@media(max-width: 768px)": {
        width: "100%",
      },
      "& .MuiDialogActions-root": {
        justifyContent: "flex-end !important",
      },
      "& .primary-coach-info": {
        display: "none",
      },
      "& .simplebar-mask": {
        position: "unset",
      },
      "& .quick-attachment": {
        paddingTop: 0,
      },
    },
    reqFeedback: {
      "& .chip": {
        "& h6": {
          maxWidth: 85,
        },
      },
    },
    formWrapper: {
      "@media(max-width: 1180px)": {
        height: "93%",
      },
    },
    formContent: {
      flex: "1 1 auto",
      height: "calc(100% - 65px)",
      "@media(max-width: 767px)": {
        marginRight: "none",
      },
      "& .attachment-list": {
        marginTop: 0,
      },
    },
    dialogActions: {
      boxShadow: "0px -3px 6px #5E5E5E12",
      padding: "12px 24px",
      width: "calc(100% - 400px)",
      width: "100%",
      "& .MuiButtonBase-root": {
        height: 40,
        minWidth: 95,
      },
    },
    toggleTxt: {
      color: "#999",
      fontSize: 13,
    },
    // preview
    preview: {
      width: 400,
      background: "#D6D8DC",
      borderRadius: "0 0 10px 0",
      "@media(max-width: 1180px)": {
        width: 350,
      },
      "@media(max-width: 768px)": {
        display: "none",
      },
      "& .MuiCard-root": {
        height: "100%",
      },
    },
    previewTitle: {
      borderBottom: "solid 1px #D6D8DC",
      padding: "0 16px",
      height: 55,
      "& h6": {
        fontSize: 16,
        fontWeight: 600,
        display: "flex",
      },
    },
    previewContent: {
      height: "calc(100% - 54px)",
      "& p, & ul": {
        fontSize: 13,
        wordBreak: "break-word",
      },
      "& .img-preview": {
        width: "100%",
        height: 130,
        objectFit: "cover",
      },
      "& .file-txt": {
        width: "100%",
      },
      "& .added-attachment": {
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
      },
    },
    emptyState: {
      "& img": {
        marginBottom: 20,
      },
      "& p": {
        color: "#4E5359",
      },
    },
    formattedInstructions: {
      "& p": {
        marginTop: 0,
        lineHeight: "18px",
      },
      "& *": {
        background: "none !important",
        color: "inherit !important",
        fontSize: "13px !important",
        fontFamily: "inherit !important",
      },
    },
    // custom survey
    emojiRankingPreview: {
      "& img": {
        marginRight: 10,
      },
    },
    starRankingPreview: {
      "& svg": {
        fontSize: 40,
        color: "#EBEDF1",
      },
    },
    mcqQusPreview: {
      borderRadius: 6,
      border: "solid 1px #E3E3E3",
      padding: "8px 12px",
      fontSize: 12,
      wordBreak: "break-all",
      "& span": {
        width: 18,
        height: 18,
        minWidth: 18,
        borderRadius: 4,
        display: "block",
        fontWeight: 500,
        marginRight: 10,
        textAlign: "center",
        lineHeight: "16px",
        border: "solid 1px #B4B4B4",
        color: "#9B9B9B",
        "&.radio-icon": {
          borderRadius: "50%",
        },
      },
    },
    // learning checkin
    linkPreview: {
      minHeight: 170,
      width: "100%",
      maxHeight: 170,
      border: "solid 1px #EEF3F8 !important",
      background: "#EEF3F8 !important",
      "& .Image": {
        minHeight: 115,
        maxHeight: 115,
        borderRadius: 4,
      },
      "& .Description": {
        display: "none",
      },
      "& .Title": {
        fontSize: 12,
        fontWeight: 400,
        margin: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .SiteDetails": {
        color: "#888B8E",
        fontSize: 12,
        fontWeight: 400,
        margin: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    imgPreview: {
      height: 120,
      objectFit: "cover",
      width: "100%",
    },
    thumbImg: {
      width: 45,
      height: 40,
      objectFit: "contain",
      marginBottom: 8,
    },
    linkTxt: {
      textAlign: "center",
      color: "#0A468D",
      textDecoration: "none",
      wordBreak: "break-all",
      width: "100%",
    },
    downloadBtn: {
      border: "solid 2px #F0F0F0",
      width: 36,
      height: 36,
      position: "absolute",
      bottom: 8,
      right: 8,
      "& svg": {
        borderBottom: "solid 1.5px",
        fontSize: 16,
        borderBottomColor: theme.palette.primary.main,
      },
    },
    checkinUploadFile: {
      "& .upload-card": {
        height: 130,
      },
      "& .MuiDropzoneArea-textContainer": {
        flexDirection: "column-reverse !important",
        "& img": {
          marginRight: 0,
        },
      },
      "& .MuiDropzoneArea-icon, & .MuiDropzoneArea-text": {
        margin: "0 !important",
        width: 150,
      },
      "& .paste-link-form": {
        flexDirection: "column",
        padding: 24,
        justifyContent: "center",
        "& p": {
          textAlign: "center",
        },
      },
      "& .rotate-icon": {
        margin: 0,
      },
    },
    checkinAttachment: {
      "& .attachment-list": {
        margin: 0,
      },
      "& .added-attachment": {
        maxWidth: 228,
        width: "auto",
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
      },
    },
    // survey 360
    accordionParent: {
      boxShadow: "none",
      "& .MuiAccordionSummary-root": {
        padding: 0,
        "& .MuiIconButton-root": {
          marginRight: -5,
        },
      },
      "& .MuiAccordionDetails-root": {
        padding: 0,
        display: "block",
        marginBottom: 8,
      },
      "& .MuiAccordionSummary-root.Mui-expanded": {
        minHeight: 36,
      },
      "& .MuiAccordionSummary-content.Mui-expanded": {
        margin: "15px 0",
      },
    },
    mainHeading: {
      fontWeight: 600,
    },
    subAccordion: {
      boxShadow: "none",
      borderRadius: "10px !important",
      border: "solid 1px #CCCCCC",
      marginRight: 10,
      width: "100%",
      marginBottom: 8,
      "&:before": {
        content: "none",
      },
      "& .MuiAccordionSummary-content": {
        padding: "0 0 0 10px",
        width: "88%",
        "& p": {
          // maxWidth: 250,
          padding: "0 10px",
        },
      },
      "& .MuiIconButton-edgeEnd": {
        marginRight: "0 !important",
      },
      "& .MuiAccordionDetails-root": {
        padding: "8px 16px",
        display: "block",
      },
      "& .Mui-expanded": {
        "& p": {
          whiteSpace: "unset",
        },
      },
    },
    ratingBtn: {
      borderRadius: 6,
      border: "solid 1px #E3E3E3",
      width: 120,
      padding: "6px 10px",
      marginBottom: 6,
    },
    templateRadio: {
      width: "100%",
      padding: "20px 15px",
      borderBottom: "1px solid #EDEDED",
      marginBottom: "20px",
      "& .MuiCard-root": {
        textAlign: "center",
        padding: "15px",
        fontSize: "14px",
        background: "#FAFAFA",
        borderRadius: "0",
        border: "1px solid #EDEDED",
        width: "100%",
        boxShadow: "none",
        "& .MuiTypography-root.font-14": {
          marginBottom: "10px",
          textAlign: "left",
        },
        "& .MuiFormGroup-root, & .MuiFormControlLabel-root": {
          textAlign: "left",
          "& .MuiTypography-root": {
            textAlign: "left",
            fontSize: "14px",
            fontWeight: "400",
            display: "block",
            fontFamily: `'Poppins', sans-serif`,
          },
        },
        "& .MuiFormControlLabel-root": {
          marginRight: "0",
          marginLeft: "left",
        },
        "& .MuiBox-root": {
          "& .MuiGrid-root": {
            // width: "34%",
            display: "inline-block",
            marginRight: "15px",
            verticalAlign: "top",
            marginBottom: "10px",
            "&:last-child": {
              marginRight: "0",
            },
            "& .MuiBox-root": {
              marginBottom: "0",
            },
          },
        },
      },
      "& .MuiFormControl-root": {
        textAlign: "left",
        width: "100%",
        border: "1px solid #EDEDED",
        // background: "#FAFAFA",
      },
    },
    Popover: {
      "& .MuiButtonBase-root": {
        background: "#FFFFFF",
        border: "1px solid #EFEFEF",
        borderRadius: "10px",
        padding: "20px",
        textAlign: "left",
      },
    },
    uploadFileCustom: {
      "& input": {
        display: "none",
      },
    },
    attachedFile: {
      border: "solid 1px #ECEEF2",
      background: "#F1F3F7",
      borderRadius: 6,
      padding: "4px 6px",
      color: "#707E8C",
      "& img": {
        width: 18,
        height: 23,
        marginRight: 10,
      },
      "& p": {
        maxWidth: 200,
      },
    },
    questionListItem: {
      borderRadius: 4,
      border: "solid 1px #E6E4E4",
      background: "#fff",
      height: 82,
    },
    questionSelected: {
      border: "solid 1px #FFD7B5",
      background: "#FAF2EC",
      borderLeft: "solid 3px #F3994E",
      height: 82,
      "& svg": {
        color: "#F3994E",
      },
    },
    disabledField: {
      pointerEvents: "none",
    },
    previewIndicator: {
      position: "fixed",
      left: 0,
      bottom: 0,
      color: "#fff",
      "& svg": {
        width: 50,
        height: 28,
      },
    },
    checkinImgWrapper: {
      background: `url(${CheckinBgImg}) no-repeat`,
      backgroundPosition: "center",
    },
    attachmentModal: {
      "& .thumb-img": {
        padding: "3px 0",
      },
      "& .paste-link-form": {
        display: "block",
        textAlign: "center",
      },
      "& .MuiDropzoneArea-root": {
        marginTop: 4,
      },
      "& .MuiDropzoneArea-text": {
        padding: "0 15%",
        "& p": {
          lineHeight: "16px",
          margin: "5px 0",
        },
      },
      "& .added-attachment": {
        width: "100%",
        maxWidth: "100%",
        marginRight: 0,
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
      },
    },
    multimedia: {
      "& .upload-card, .MuiDropzoneArea-root, .MuiInputBase-input, .dropzone-loader":
        {
          background: "unset",
        },
      "& .add-btn": {
        margin: "6px 0 0",
      },
      "& .added-attachment": {
        width: "auto",
        height: 41,
        fontSize: 13,
        margin: "4px 8px 4px 0",
        "& img": {
          width: 16,
        },
        "& .thumb-img": {
          width: 20,
          marginRight: 5,
        },
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
      },
    },
    surveyMediaBtn: {
      marginTop: -32,
      marginBottom: 10,
    },
    modalLaunchDate: {
      [theme.breakpoints.up("sm")]: {
        "& .MuiGrid-grid-sm-5": {
          maxWidth: "55%",
          flexBasis: "55%",
        },
      },
      "& .duration-field": {
        maxWidth: 125,
        flexBasis: 125,
        "& .input-box": {
          width: 140,
        },
      },
    },
    daySelection: {
      "& button": {
        width: 32,
        height: 40,
        background: "#FAFAFA",
        borderRadius: 2,
        border: "solid 1px #F1F1F1",
        fontSize: 14,
        color: "#707070",
        minWidth: 32,
        marginRight: 8,
        "&.selected-day": {
          background: "#FFECDC",
          color: "#EE6429",
          fontWeight: 600,
          border: "solid 1px #F7E3D3",
        },
      },
    },
    frequencyModal: {
      "&.MuiDialog-root": {
        zIndex: "1300 !important",
      },
    },
    customRadio: {
      "& .MuiFormControlLabel-root": {
        marginRight: 0,
      },
    },
    editIcon: {
      position: "absolute",
      top: -2,
      left: 85,
    },
    frequencyListPopover: {
      width: 220,
      "& ul": {
        padding: 0,
        margin: 0,
        listStyle: "none",
        "& li": {
          display: "flex",
          textAlign: "center",
          marginBottom: 4,
          "&:first-child": {
            "& p": {
              "&:after": {
                content: "none",
              },
            },
          },
          "& p": {
            width: "50%",
            "&:first-child": {
              position: "relative",
              "&:after": {
                content: "'-'",
                position: "absolute",
                right: -3,
                top: 0,
              },
            },
          },
        },
      },
    },
    attachmentChip: {
      maxWidth: 228,
      height: 41,
      marginRight: 8,
      borderRadius: 5,
      transition: ".5s",
    },
    thumbnailImg: {
      width: 24,
      minWidth: 24,
      "& img": {
        width: 18,
        objectFit: "contain",
        display: "block",
        maxHeight: "100%",
        marginRight: 5,
      },
    },
    pastedLink: {
      "& p": {
        width: "95%",
      },
    },
    fileName: {
      width: "90%",
      fontSize: 13,
      color: "#5E6066",
      textDecoration: "none",
      fontWeight: "400 !important",
      textDecoration: "none",
      "& a": {
        textDecoration: "none",
        color: "#07519C",
      },
    },
    multimediaBox: {
      "& .file-wrapper": {
        flexWrap: "wrap",
        display: "flex",
      },
      "& .attachment-label": {
        fontSize: 13,
        fontWeight: 500,
        margin: 0,
      },
      "& .added-attachment": {
        "&:hover": {
          boxShadow: "0px 1px 4px #0000001A",
        },
        "& .link-txt": {
          width: "100%",
        },
        "& a": {
          textDecoration: "none",
        },
      },
    },
    numberInput: {
      "& input::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "& input::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
      },
    },
    frequencySelectField: {
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "#2E2E2E",
      },
    },
    checkinMedia: {
      "& .MuiTypography-body2": {
        fontWeight: 500,
      },
    },
  };
});
